import React from 'react'
import './electric.less'
import { setHeader } from '@/util/set-header'
import { List, Toast } from 'antd-mobile'
import SelectPay from '../common/select-pay/select-pay'
import { fetchPayBase, electricConfigApi } from '@/api/payment'
import { connect } from 'react-redux'
import PayGroup from './../common/pay-group'
const Item = List.Item
const mapStateToProps = (state: any) => {
  return {
    info: state.payment,
  }
}
@(connect(mapStateToProps) as any)
class Electric extends React.Component<any, any> {
  //非智能房间 电费充值梯度
  private no_intelligence = [
    { money: '10' },
    { money: '20' },
    { money: '30' },
    { money: '50' },
    { money: '100' },
    { money: '200' },
  ]
  constructor(props: any) {
    super(props)
    this.state = {
      info: {},
      electric: {},
      payType: 'alipay',
      electrityArray: [],
      is_intelligence: false,
      eleIndex: 0,
      eleText: '',
      elePrice: 0,
      store_no: '',
      room_no: '',
      bed_no: '',
    }
  }
  leftClick = () => {
    const { history } = this.props
    if(history.length>1){
      history.goBack()
    }else{
      if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
    }
  }
  UNSAFE_componentWillMount() {
    setHeader({ title: '缴费', leftClick: this.leftClick })
    Toast.loading('加载中', 0)
  }
  async componentDidMount() {
    const { info } = this.props
    if (info.checkin_id) {
      const data = await Promise.all([
        this.getBaseInfo(info.checkin_id),
        this.getElectricConfig(info.checkin_id),
      ])
      if(data.every(v=>v)){
        Toast.hide()
      }
    }
  }
  async componentWillReceiveProps(nextProps: any) {
    const nextInfo = nextProps.info
    const { info } = this.props
    if (nextInfo.checkin_id==='') {
      Toast.info('您当前可能还未入住，请入住后在缴费哦~',2,()=>{
          if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
      })
      return
  }
    if (info.checkin_id !== nextInfo.checkin_id) {
      const data = await Promise.all([
        this.getBaseInfo(nextInfo.checkin_id),
        this.getElectricConfig(nextInfo.checkin_id),
      ])
      if(data.every(v=>v)){
        Toast.hide()
      }
 
    }
  }
  //获取费用基本信息
  getBaseInfo = async (checkin_id: string) => {
    let { data } = await fetchPayBase(checkin_id)
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 2, () => {
        if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
      })
      return
    }
    const { info, electric } = data.data
    this.setState({
      info,
      electric,
      store_no: data.data.info.store_no,
      room_no: data.data.info.room_no,
      bed_no: data.data.info.bed_no,
    })
    return true
  }
  //获取智能电表梯度
  getElectricConfig = async (checkin_id: string) => {
    let { data } = await electricConfigApi(checkin_id)
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 2, () => {
        if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
      })
      return
    }
    const {
      is_intelligence,
      money_10,
      money_20,
      money_40,
      money_60,
      money_100,
      money_200,
    } = data.data
    let electrityArray: any = []
    if (is_intelligence) {
      electrityArray = [
        { money: money_10, level: '10度' },
        { money: money_20, level: '20度' },
        { money: money_40, level: '40度' },
        { money: money_60, level: '60度' },
        { money: money_100, level: '100度' },
        { money: money_200, level: '200度' },
      ]
    } else {
      electrityArray = this.no_intelligence
    }
    let eleText = is_intelligence
      ? `${electrityArray[0].money} ( ${electrityArray[0].level} ) `
      : `${electrityArray[0].money}元`
    let elePrice = electrityArray[0].money

    this.setState({
      eleText,
      elePrice,
      is_intelligence,
      electrityArray,
    })
    return true
  }
  stepperChange = (num: any) => {
    this.setState({ cycle: num })
  }

  payTypeChange = (payType: string) => {
    this.setState({
      payType: payType,
    })
  }
  moneyChange = (index: number) => {
    const { is_intelligence, electrityArray } = this.state
    let eleText = is_intelligence
      ? `${electrityArray[index].money} ( ${electrityArray[index].level} ) `
      : `${electrityArray[index].money}元`
    let elePrice = electrityArray[index].money
    this.setState({
      eleText,
      elePrice,
      eleIndex: index,
    })
  }

  loadData = () => {
    const { elePrice, payType, electric } = this.state
    const { subject_id, subject_name } = electric
    return {
      pay_type: payType,
      cost_data: [
        {
          money: elePrice,
          subject_id,
          subject_name,
        },
      ],
    }
  }
  render() {
    const {
      electrityArray,
      is_intelligence,
      eleIndex,
      eleText,
      elePrice,
    } = this.state
    const { name } = this.props.info
    const butList = electrityArray.map((item: any, index: number) => (
      <div
        className={eleIndex === index ? 'but-active' : ''}
        key={index}
        onClick={() => this.moneyChange(index)}
      >
        <span className="font-6 crude">
          {is_intelligence ? item.level : `${item.money}元`}
        </span>
        {is_intelligence && <span className="font-8">{`${item.money}元`}</span>}
      </div>
    ))
    return (
      <List className="electric">
        <div className="list">
          <Item extra={<span className="black_cor">{name}</span>}>缴费人</Item>
          <Item
            extra={
              <span className="black_cor">{`${this.state.store_no}-${
                this.state.room_no
              }-${this.state.bed_no}`}</span>
            }
          >
            房间号
          </Item>

          <Item
            style={{ marginTop: '0.1rem' }}
            extra={<span className="red_cor">电费</span>}
          >
            缴费项目
          </Item>
          <Item extra={<span className="black_cor">{eleText}</span>}>
            充值金额
          </Item>
          <div className="item-list">{butList}</div>
          <SelectPay
            payType={this.state.payType}
            onChange={this.payTypeChange}
          />
        </div>

        <PayGroup money={elePrice} loadData={this.loadData} />
      </List>
    )
  }
}

export default Electric
